import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoader: false,
  runLoader: false,
  statsLoader: false,
  shareLoader: false,
  enableLoader: false,
  assessments: {},
  stats: {},
  currentReport: {},
  shareResult: {},
  enableResult: {},
  listFilters: {},
};

const adminRiskAssessmentsSlice = createSlice({
  name: "adminRiskAssessments",
  initialState,
  reducers: {
    resetAdminRiskAssessmentsState: () => initialState,
    setListFilters: (state, action) => {
      state.listFilters = action.payload || {};
    },
    fetchAssessmentsList: (state) => {
      state.listLoader = true;
    },
    assessmentsListLoaded: (state, action) => {
      state.listLoader = false;
      state.assessments = action.payload || {};
    },
    fetchAssessmentStats: (state) => {
      state.statsLoader = true;
    },
    assessmentStatsLoaded: (state, action) => {
      state.statsLoader = false;
      state.stats = action.payload || {};
    },
    runAssessment: (state) => {
      state.runLoader = true;
    },
    assessmentRunComplete: (state, action) => {
      state.runLoader = false;
      if (action.payload?.success) {
        state.currentReport = action.payload;
      }
    },
    clearCurrentReport: (state) => {
      state.currentReport = {};
    },
    shareAssessment: (state) => {
      state.shareLoader = true;
    },
    assessmentShared: (state, action) => {
      state.shareLoader = false;
      state.shareResult = action.payload || {};
    },
    enableAssessmentMonitoring: (state) => {
      state.enableLoader = true;
    },
    assessmentMonitoringEnabled: (state, action) => {
      state.enableLoader = false;
      state.enableResult = action.payload || {};
      if (action.payload?.success && state.currentReport?.data?.id) {
        state.currentReport = {
          ...state.currentReport,
          data: {
            ...state.currentReport.data,
            free_subscription: true,
            monitoring_enabled: true,
          },
        };
      }
    },
  },
});

export const adminRiskAssessmentsAction = adminRiskAssessmentsSlice.actions;
export default adminRiskAssessmentsSlice.reducer;
